<div class="view-container">
  <mat-card class="batch-create-card">
    <div class="batch-create-card__header">
      <div class="batch-create-card__title-row">
        <div class="batch-create-card__icon">
          <mat-icon>add_box</mat-icon>
        </div>
        <div>
          <h1 class="batch-create-card__title">New batch</h1>
          <p class="batch-create-card__subtitle">Create a new medicine batch</p>
        </div>
      </div>
    </div>

    <form class="batch-create-card__form">
      <div [formGroup]="batchDetailsForm">
        <div class="row g-2">
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="batch-create-card__field">
              <mat-label>Batch number</mat-label>
              <input required type="text" formControlName="batchNumber" matInput placeholder="Batch number" />
              @if (batchDetailsForm.get('batchNumber')?.invalid) {
                <mat-error>Batch number is invalid</mat-error>
              }
              <mat-hint>Examples AMI001, BOLT025, ABC2345</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="batch-create-card__field">
              <mat-label>Quantity</mat-label>
              <input required type="number" min="1" max="1000" formControlName="quantity" matInput placeholder="Quantity" />
              @if (batchDetailsForm.get('quantity')?.invalid) {
                <mat-error>Batch quantity is invalid</mat-error>
              }
              <mat-hint>A minimum of 1 and a maximum of 1000</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="batch-create-card__field">
              <mat-label>Select package type</mat-label>
              <mat-select
                required
                [disabled]="isLoading || medicineDosageTypePackageTypes.length === 0"
                formControlName="packageTypeId"
              >
                @for (type of medicineDosageTypePackageTypes; track type) {
                  <mat-option value="{{ type.id }}">
                    {{ type.package_type.type }} ({{ type.contained_quantity }})
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="batch-create-card__field">
              <mat-label>Expiry date</mat-label>
              <input
                required
                data-testid="expiry-date"
                formControlName="expiryDate"
                matInput
                [matDatepicker]="picker1"
                [min]="minDate"
              />
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
              @if (batchDetailsForm.get('expiryDate')?.invalid) {
                <mat-error>Expiry date is invalid</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline" class="batch-create-card__field">
              <mat-label>Search for medicine</mat-label>
              <input
                required
                [disabled]="isLoading"
                type="text"
                placeholder="Search for medicine"
                aria-label="Search for medicine"
                matInput
                formControlName="medicine"
                [matAutocomplete]="auto"
              />
              <mat-autocomplete
                (optionSelected)="medicineSelected($event)"
                autoActiveFirstOption
                #auto="matAutocomplete"
              >
                @for (med of medicine; track med) {
                  <mat-option [value]="med">
                    {{ med.name }}
                  </mat-option>
                }
              </mat-autocomplete>
              <mat-icon matPrefix>search</mat-icon>
            </mat-form-field>

            <mat-form-field appearance="outline" class="batch-create-card__field">
              <mat-label>Dosage type</mat-label>
              <mat-select
                required
                [disabled]="isLoading || !selectedMedicine"
                formControlName="dosageTypeId"
                (selectionChange)="getMedicineDosagePackageTypes($event)"
              >
                @for (type of dosageTypes; track type) {
                  <mat-option [value]="type.id">
                    {{ type.additional_information }}
                  </mat-option>
                }
              </mat-select>
              @if (batchDetailsForm.get('dosageTypeId')?.invalid) {
                <mat-error>Batch dosage type is invalid</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" class="batch-create-card__field">
              <mat-label>Status</mat-label>
              <mat-select required [disabled]="isLoading" formControlName="statusId">
                @for (status of batchStatuses; track status) {
                  <mat-option [value]="status.id">{{ status.status }}</mat-option>
                }
              </mat-select>
              @if (batchDetailsForm.get('statusId')?.invalid) {
                <mat-error>Status is invalid</mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        <div class="batch-create-card__editor">
          <h2 class="batch-create-card__section-title">Additional information</h2>
          <quill-editor
            formControlName="additional_information"
            format="html"
            [styles]="{ minHeight: '100px' }"
          >
          </quill-editor>
        </div>
      </div>
    </form>

    <div class="batch-create-card__footer">
      <button
        type="button"
        [disabled]="!batchDetailsForm.valid"
        mat-flat-button
        color="primary"
        class="batch-create-card__btn--primary"
        (click)="submitData()"
      >
        <mat-icon>save</mat-icon>
        Save
      </button>
    </div>
  </mat-card>
</div>
